{/* This is a actually Dessert Menu, Now it is Single Menu */}
const dessert = [
    {
        id: 1,
        name: 'Chicken Curry : チキンカレー',
        description: 'Juicy chicken pieces simmered in a rich tomato-onion gravy with traditional spices',
        price: '¥900'
    },
    {
        id: 2,
        name: 'Vegetable Curry : ベジタブルカレー',
        description: 'Seasonal vegetables cooked in a mildly spiced curry with a touch of cream',
        price: '¥850'
    },
    {
        id: 3,
        name: 'Sag Chicken Curry : サグチキンカレー',
        description: 'Tender chicken cooked with fresh spinach, garlic, and aromatic spices',
        price: '¥1000'
    },
    {
        id: 4,
        name: 'Chicken Karahi : チキンカラヒ',
        description: 'A classic North Indian dish with chicken stir-fried in tomatoes, ginger, and green chilies',
        price: '¥900'
    },
    {
        id: 5,
        name: 'Chicken Tikka Masala : チキンティッカマサラ',
        description: 'Grilled chicken tikka simmered in a creamy tomato-based sauce with fragrant spices',
        price: '¥1050'
    },
    {
        id: 6,
        name: 'Mutton Curry : マトンカレー',
        description: 'Tender pieces of mutton slow-cooked in a spiced onion and tomato gravy',
        price: '¥1000'
    },
    {
        id: 7,
        name: 'Keema Matar Masala : キーママタルマサラ',
        description: 'Minced meat cooked with green peas, onions, and aromatic spices',
        price: '¥1000'
    },
    {
        id: 8,
        name: 'Sag Mutton Curry : サグマトンカレー',
        description: 'Slow-cooked mutton blended with fresh spinach, garlic, and traditional spices',
        price: '¥1050'
    },
    {
        id: 9,
        name: 'Mutton Karahi : マトンカラヒ',
        description: 'Succulent mutton pieces cooked in a wok-style curry with tomatoes, ginger, and green chilies',
        price: '¥1000'
    },
    {
        id: 10,
        name: 'Beef Curry : ビーフカレー',
        description: 'Tender beef chunks simmered in a hearty onion-tomato gravy with traditional spices',
        price: '¥900'
    },
    {
        id: 11,
        name: 'Chicken Biryani : チキンビリヤニ',
        description: 'Fragrant spiced rice cooked with tender chicken, a popular dish',
        price: '¥900'
    },
    {
        id: 12,
        name: 'Mutton Pulao : マトンプラオ',
        description: 'Tender mutton cooked together with fragrant basmati rice',
        price: '¥1,000'
    },
    {
        id: 13,
        name: 'Tandoori Chicken : タンドリーチキン',
        description: 'Chicken marinated in spices and roasted in a tandoor oven',
        price: '2pcs ￥650 | 4pcs ￥1,050'
    },
    {
        id: 14,
        name: 'Malai Tikka : マライティッカ',
        description: 'Chicken marinated in creamy yogurt and spices, grilled to perfection',
        price: '6pcs ￥1,050'
    },
    {
        id: 15,
        name: 'Chapli Kebabu : チャプリケバブ',
        description: 'Spiced minced meat patties grilled to perfection, a traditional kebab',
        price: '2pcs ￥600'
    },
    {
        id: 16,
        name: 'Mutton Biryani : マトンビリヤニ',
        description: 'Fragrant basmati rice cooked with tender mutton and aromatic spices',
        price: '￥1,000'
    },
    {
        id: 17,
        name: 'Mutton Paya : マトンパヤ',
        description: 'A rich and nourishing curry soup made by slow-cooking mutton trotters',
        price: '￥1,000'
    },
    {
        id: 18,
        name: 'Shish Kebabu : シシケバブ',
        description: 'Skewered meat and vegetables marinated in spices and grilled to perfection',
        price: '2pcs ￥800'
    },
    {
        id: 19,
        name: 'Chicken Tikka : チキンティッカ',
        description: 'Chicken marinated in spiced yogurt and roasted in a tandoor oven',
        price: '6pcs ￥900'
    }

];

export default dessert;